import { Action, createReducer, on } from '@ngrx/store';
import { Toast, toastFactory } from '../../models';

import * as fromMessages from '../actions/messages.actions';
import * as fromErrors from '../fromErrors.barrel';

export const messageFeatureKey = 'messages';

export interface State {
  log: string[];
  toasts: Toast[];
}

export const initialState: State = {
  log: [],
  toasts: []
};

export const reducer = createReducer(
  initialState,
  on(fromMessages.addMessageToLog, (state, action) => ({
    ...state,
    log: state.log.concat(action.message)
  })),
  on(fromMessages.addToast, (state, action) => ({
    ...state,
    toasts: state.toasts.concat(action.toast)
  })),
  on(fromMessages.removeToast, (state, action) => ({
    ...state,
    toasts: state.toasts.filter(f => f.id !== action.id)
  })),
  on(fromErrors.addGlobalError, (state, action) => ({
    ...state,
    toasts: state.toasts.concat(toastFactory({
      class: 'danger',
      title: 'Error',
      message: `${!!action.error?.error?.error ? action.error.error.error.message : action.error.message}`
    }))
  }))
);
